import React from "react"
import { useSelector } from "react-redux"

import { ColumnTypeEnum } from "@/codegen/graphql-request"
import { getReferenceRecords } from "@/slice/masterRecordsSlice"
import { RootState } from "@/store"
import { ColumnData, ReferenceConfig } from "@/type"

import { TextInput } from "./TextInput"

export const TextInputForReference = (props: {
	inputValue: string
	leaveEditMode: () => void
	enterEditMode: () => void
	setInputValue: React.Dispatch<React.SetStateAction<string>>
	reference: ReferenceConfig
	isEdit: boolean
	columnType: ColumnTypeEnum
	cellData: ColumnData
}) => {
	const { inputValue, leaveEditMode, enterEditMode, setInputValue, reference, isEdit, columnType, cellData } = props

	const referenceValue = useSelector((state: RootState) => {
		const referenceRecords = getReferenceRecords(state, reference)
		if (!referenceRecords || !cellData) return ""
		if (columnType == ColumnTypeEnum.List) {
			try {
				// JSON としてパースできない文字列が入ってきたら "" を返す
				const cellDataItems: string[] = JSON.parse(cellData as string)
				return cellDataItems
					.map((cellItem) => referenceRecords.find((ref) => ref.pkData == cellItem)?.displayData || "")
					.join(",")
			} catch (e) {
				return ""
			}
		}
		return referenceRecords.find((ref) => ref.pkData == cellData)?.displayData || ""
	})

	return isEdit ? (
		<TextInput
			inputValue={inputValue}
			leaveEditMode={leaveEditMode}
			enterEditMode={enterEditMode}
			setInputValue={setInputValue}
			isEdit={isEdit}
		/>
	) : (
		<TextInput
			inputValue={referenceValue}
			leaveEditMode={leaveEditMode}
			enterEditMode={enterEditMode}
			setInputValue={setInputValue}
			isEdit={isEdit}
		/>
	)
}
